import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { VESSELS_LAST_SIGNAL, TVesselsLastSignalSliceState, TVesselInfo } from '../mapTypes';
import { RootState } from '../../../core/store';

const initialState: TVesselsLastSignalSliceState = {
	vesselsLastSignalData: null,
	vesselsLastSignalLoading: false,
	vesselsLastSignalError: null,
};

const vesselsLastSignalSlice = createSlice({
	name: VESSELS_LAST_SIGNAL,
	initialState,
	reducers: {
		getVesselsLastSignalRequestAction: (state: TVesselsLastSignalSliceState, _: PayloadAction<{imoList: number[], date: string, yearMonth: number}>) => {
			state.vesselsLastSignalLoading = true;
			state.vesselsLastSignalError = null;
		},
		getVesselsLastSignalSuccessAction: (
			state: TVesselsLastSignalSliceState,
			{ payload: data }: PayloadAction<TVesselInfo>,
		) => {
			state.vesselsLastSignalLoading = false;
			state.vesselsLastSignalData = data;
			state.vesselsLastSignalError = null;
		},
		getVesselsLastSignalErrorAction: (
			state: TVesselsLastSignalSliceState,
			{ payload: error }: PayloadAction<any>,
		) => {
			state.vesselsLastSignalData = null;
			state.vesselsLastSignalLoading = false;
			state.vesselsLastSignalError = {
				message: (error.response && error.response.data) || error.message || '',
				name: error.name,
				stack: error.stack,
			};
		},
	},
});

export const { getVesselsLastSignalRequestAction, getVesselsLastSignalSuccessAction, getVesselsLastSignalErrorAction } =
	vesselsLastSignalSlice.actions;
export default vesselsLastSignalSlice.reducer;

// select loading
export const selectVesselsLastSignalLoading = (state: RootState) => state.vesselsLastSignalSlice.vesselsLastSignalLoading;
